import { gql } from "@apollo/client"

export const GET_TEMPLATE = gql`
  query ListPageView(
    $organization_id: ID!
    $idTemplate: ID!
    $idBlocks: [ID]
    $numberOfDays: Int
    $dateField: String
    $activityField: String
    $startDate: String
    $endDate: String
    $locationFilter: [String]
    $staffFilter: [String]
    $programFilter: [String]
  ) {
    data: getFilteredTemplates(
      organization_id: $organization_id
      idTemplate: $idTemplate
      idBlocks: $idBlocks
      numberOfDays: $numberOfDays
      dateField: $dateField
      activityField: $activityField
      startDate: $startDate
      endDate: $endDate
      locationFilter: $locationFilter
      staffFilter: $staffFilter
      programFilter: $programFilter
    ) {
      data
      error {
        message
      }
      rowCount
    }
  }
`

export const LIST_BY_DATE = gql`
  query ListPagePager(
    $organization_id: ID!
    $idTemplate: ID!
    $idBlocks: [ID]
    $numberOfDays: Int
    $dateField: String
    $activityField: String
    $startDate: String
    $endDate: String
    $locationFilter: [String]
    $staffFilter: [String]
    $programFilter: [String]
  ) {
    data: getFilteredTemplates(
      organization_id: $organization_id
      idTemplate: $idTemplate
      idBlocks: $idBlocks
      numberOfDays: $numberOfDays
      dateField: $dateField
      activityField: $activityField
      startDate: $startDate
      endDate: $endDate
      locationFilter: $locationFilter
      staffFilter: $staffFilter
      programFilter: $programFilter
    ) {
      data
      error {
        message
      }
      rowCount
    }
  }
`
